module.exports = __webpack_public_path__ + "img/more_circle.70175213.svg";